import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { LOGOS } from "../data/site";

export const PageWipe = () => {
  const location = useLocation();
  const [active, setActive] = useState(false);
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setActive(true);
    window.scrollTo(0, 0);
    const t = setTimeout(() => setActive(false), 850);
    return () => clearTimeout(t);
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {active && (
        <motion.div
          key="wipe"
          data-testid="page-wipe"
          className="fixed inset-0 z-[999] flex items-center justify-center bg-charcoal"
          initial={{ clipPath: "inset(0 0 100% 0)" }}
          animate={{ clipPath: "inset(0 0 0% 0)" }}
          exit={{ clipPath: "inset(100% 0 0 0)" }}
          transition={{ duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.7 }}
            animate={{ opacity: [0, 1, 1, 0], scale: [0.7, 1, 1, 1.1] }}
            transition={{ duration: 0.85, times: [0, 0.3, 0.7, 1] }}
          >
            <img src={LOGOS.yellow} alt="Chicken Labb" className="h-24 w-auto sm:h-28" />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
